module.exports = __webpack_public_path__ + "img/intercom.5af4effe.png";